import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpXhrBackend,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { isTauri } from 'src/app/core/tauri/tauri-http';

/**
 * L'app utilise le backend HTTP `fetch` (provideHttpClient(withFetch())),
 * mais l'API Fetch ne peut pas suivre la progression de l'ENVOI d'un corps de
 * requête : HttpEventType.UploadProgress n'est jamais émis. Les imports de
 * gros fichiers (audio…) restaient donc bloqués à 1 % pendant tout l'upload,
 * puis sautaient d'un coup à 100 %.
 *
 * Cet intercepteur, enregistré en dernier dans HTTP_INTERCEPTORS (donc après
 * TokenInterceptor, qui a déjà posé l'en-tête Authorization), route les
 * requêtes avec reportProgress vers le backend XHR, seul capable d'émettre
 * la progression réelle de l'upload.
 *
 * En desktop Tauri on garde fetch : les requêtes passent par le client HTTP
 * Rust (contournement du CORS de la webview), un XHR direct serait rejeté.
 */
@Injectable()
export class UploadProgressInterceptor implements HttpInterceptor {
  constructor(private xhrBackend: HttpXhrBackend) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.reportProgress && request.body != null && !isTauri()) {
      return this.xhrBackend.handle(request);
    }
    return next.handle(request);
  }
}
